import { useEffect } from "react"
import { useAppDispatch } from "integrations/redux/hooks"
import { setOverlayStatus } from "features/map/control/slice"
import { OverlayKey } from "features/map/control/types"
import { LayerStatus } from "./layerStatus"

export function useReportOverlayStatus(key: OverlayKey, status: LayerStatus) {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(setOverlayStatus({ key, status }))
    }, [key, status, dispatch])
}
